import { Injectable } from '@angular/core';

import { FinanciacionPrivadaService } from '../../../../modules/finanzas/financiacion-privada/financiacion-privada.service';
import { FinanciacionPrivadaModel } from '../../../../modules/finanzas/financiacion-privada/financiacion-privada.model';
import { ensureOk } from '../../entity-form/entity-form.utils';

@Injectable({ providedIn: 'root' })
export class PrivateFinancingEntityService {

  constructor(private financiacionPrivadaService: FinanciacionPrivadaService) { }

  get(uid: string): Promise<FinanciacionPrivadaModel> {
    return this.financiacionPrivadaService.get(uid).then(financing => {
      if (!financing) throw new Error();
      return financing;
    });
  }

  create(payload: FinanciacionPrivadaModel): Promise<void> {
    return this.financiacionPrivadaService.add(payload).then(() => undefined);
  }

  update(uid: string, payload: FinanciacionPrivadaModel): Promise<void> {
    return this.financiacionPrivadaService.edit({ ...payload, uid }).then(ensureOk);
  }
}
